<div class="order-card">
	<div class="order-header" *ngIf="orderValue">
		<app-order-item-header-info [orderValue]="orderValue"></app-order-item-header-info>
	</div>

	<app-order-item-status-section [orderValue]="orderValue" (sendOrderStatusChange)="updateStatus($event)"></app-order-item-status-section>

	<div class="order-details">
		@if (discount$ | async) { @if (orderValue.promoCode && orderValue.promoCode.code && getDiscountSum() != 0) {
		<div class="order-item promo">
			<div class="title">Promo Code</div>
			<div class="discount-row">
				<span class="discount-name-ph">name:</span>
				<span class="discount-name">{{ orderValue.promoCode?.name }}</span>
			</div>
			<div class="discount-row">
				<span class="discount-sum-ph">discount: </span>
				<span class="discount-sum">{{ numberToCurrency(getDiscountSum(), 'EUR') }}</span>
			</div>
		</div>
		} }

		<div class="order-item" *ngFor="let item of orderValue.orderedArticles">
			<app-order-item-articlegroup-draw [articleGroup]="item" [orderStatus]="orderValue.status"></app-order-item-articlegroup-draw>
		</div>
	</div>
</div>
